export const GQL_OPERATION_NAME = 'searchThirdPartyFilterOptions';

export const getThirdPartyFilterOptionsQuery = () => `
query ${GQL_OPERATION_NAME}($cloudId: ID!, $datasourceId: String!) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;
